export default __webpack_public_path__ + "static/media/soundrails.bfebd758.png";